import React from "react";
import PropTypes from 'prop-types';
import { Button, Input } from "reactstrap";
import { availableOperations } from '../availableOperations';

const AdvancedFilterItem = (props) => {
  const { columns, datasource, icon, order, onActionClick, onChange } = props;
  const selectedColumn = columns.find(col => col.value === datasource.column);
  const operations = selectedColumn ? availableOperations[selectedColumn.type] : [];
  const Icon = icon;
  const inputType = columns.find(col => col.value === datasource.column)?.type || 'text';

  return (
    <div id="advanced-search">
      <Input 
        name="column" 
        type="select" 
        className="advanced-filter-select" 
        bsSize="sm"
        data-item-order={order}
        onChange={onChange}
        value={datasource.column}>
        <option value="">Coluna...</option>
        {
          columns.map((col, index) => {
            return (
              <option key={`ColumnOption_${index}`} value={col.value}>{col.label}</option>
            );
          })
        }
      </Input>
      <Input 
        name="operation" 
        type="select" 
        className="advanced-filter-select" 
        bsSize="sm"
        data-item-order={order}
        onChange={onChange}
        value={datasource.operation}>
        <option value="">Condição...</option>
        {
          operations.map((op, index) => {
            return(
              <option key={`OperationOption_${index}`} value={op.value}>{op.label}</option>
            );
          })
        }
      </Input>
      <Input 
        name="searchValue" 
        type={inputType} 
        bsSize="sm" 
        className="advanced-filter-input"
        data-item-order={order}
        onChange={onChange}
        value={datasource.searchValue} />
      <Button size="sm" onClick={onActionClick}><Icon /></Button>
    </div>
  );
};

AdvancedFilterItem.propTypes = {
  onActionClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  order: PropTypes.number.isRequired,
  datasource: PropTypes.object.isRequired,
  icon: PropTypes.object.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  })).isRequired,
};

export default AdvancedFilterItem;